<template>
  <div>
    <HeadInfo title="综艺" />
    <EpisodeTvshow />
    <Relative />
    <Actors />
    <Like />
    <Gotop />
    <Rec />
    <Ob />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Gotop from '../common/components/Gotop.vue';
import pageExpose from '../common/mixins/pageExpose';
import Actors from './components/Actors.vue';
import EpisodeTvshow from './components/Episode_tvshow.vue';
import HeadInfo from './components/HeadInfo.vue';
import Like from './components/Like.vue';
import Ob from './components/ObserveModule.vue';
import Rec from './components/Rec.vue';
import Relative from './components/Relative.vue';

export default {
  components: {
    HeadInfo,
    EpisodeTvshow,
    Relative,
    Actors,
    Like,
    Gotop,
    Rec,
    Ob,
  },
  mixins: [pageExpose],
  computed: {
    ...mapState('detail', ['itemData']),
    getItem() {
      return this.itemData || {};
    },
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('detail/prefetchData', { context, route })
      .catch(err => console.log('[DETAIL_TVSHOW_PREFETCH_ERROR]', err));
  },
};
</script>
